import { Alert } from 'bold-ui'
import { formatDurationToMonthsAndDays } from 'util/date/formatDuration'

import { MChatRiscoPrevioRelevanteInfoModel } from '../mchat/model-mchat'
import { MCHAT_RESULTADOS } from '../model-mChatRf'

interface MChatRAnteriorAlertProps {
  alerta: MChatRiscoPrevioRelevanteInfoModel
}

export function MChatRAnteriorAlert(props: Readonly<MChatRAnteriorAlertProps>) {
  const { alerta } = props

  if (!alerta) return null

  const tempo = formatDurationToMonthsAndDays(alerta.duracaoDesdeRiscoPrevio)

  const { status, title } = MCHAT_RESULTADOS[alerta.risco]

  return (
    <Alert type={status} inline style={{ width: '100%' }}>
      Foi calculado <strong>{title}</strong> {tempo.toLowerCase()}. Investigue possíveis encaminhamentos para
      intervenção precoce.
    </Alert>
  )
}
